import React from "react"
import { Field, Form } from "react-final-form"

import { styled } from "@mui/material"

import { useTranslations } from "@cirrus/core/i18n/provider"
import { TextButton } from "@cirrus/ui-kit-ts/src/components/atoms/Button/TextButton"

import { LoginWithPasswordErrorHelperText } from "./ErrorHelperText"
import { LoginWithPasswordFormFieldNames } from "./types"
import { useLoginWithPassword } from "./useLoginWithPassword"
import { PasswordField } from "../../components/PasswordField"
import { StyledLoginForm } from "../../components/StyledLoginForm"
import { SubmitButton } from "../../components/SubmitButton"
import { TextFieldLogon } from "../../components/TextFieldLogon"
import { useNavigationService } from "../../providers/NavigationService"

const LOGIN_INPUT_ID = "login-input-id"

export const LoginWithCirrusPlatformForm = () => {
  const { navigate } = useNavigationService()
  const { i18n } = useTranslations()
  const {
    handleLogin, error, submitting, cleanError
  } = useLoginWithPassword()

  return <Form onSubmit={handleLogin}
               render={({ handleSubmit, values }) => <StyledLoginFormX
                 onSubmit={handleSubmit}>
                   <Field name={LoginWithPasswordFormFieldNames.username}>
                     {({ input }) =>
                       <TextFieldLogon
                         id={LOGIN_INPUT_ID}
                         {...input} width="auto" type="text" autoComplete="off"
                         placeholder={i18n("Login:Username")}
                         label={i18n("Login:Username")}
                         error={!!error}
                         inputProps={{
                           "aria-labelledby": LOGIN_INPUT_ID
                         }}
                         disabled={submitting}
                         onChange={(event) => {
                           !!error && cleanError()
                           input.onChange(event)
                         }} />
                     }
                   </Field>

                   <PasswordField name={LoginWithPasswordFormFieldNames.password} textFieldProps={{
                     error: !!error,
                     helperText: !!error && <LoginWithPasswordErrorHelperText error={error.error} />,
                     disabled: submitting,
                     placeholder: i18n("Login:Password"),
                     executeOnChange: cleanError
                   }} />

                 <SubmitButton label={i18n("Account.Login:Login")} type="submit"
                               isLoading={submitting}
                               disabled={submitting} />

                 <TextButton id="helpButton" label={i18n("Account.Login:ForgotPasswordLinkButton")} type="button"
                             onClick={() => navigate("/reset-password")} />

               </StyledLoginFormX>} />
}

const StyledLoginFormX = styled(StyledLoginForm)({

  "& .MuiButtonBase-root:nth-of-type(2)": {
    fontSize: "12px",
    fontWeight: "400",
    justifyContent: "flex-start",
    padding: "0"
  }
})
